import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from 'vbrick-player-src/pipes/Pipes.Module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SharedModule } from '../../shared/Shared.Module';

import { VbScrubBarCurrentTimeBubbleComponent } from './VbScrubBarCurrentTimeBubble.Component';
import { VbScrubBarCurrentTimeComponent } from './VbScrubBarCurrentTime.Component';
import { VbTimeMarkersComponent } from './VbTimeMarkers.Component';
import { VgControlsComponent } from './VgControls.Component';
import { VgFullscreenButtonComponent } from './VgFullscreenButton.Component';
import { VgMuteButtonComponent } from './VgMuteButton.Component';
import { VgPlayPauseButtonComponent } from './VgPlayPauseButton.Component';
import { VgScrubBarComponent } from './VgScrubBar.Component';
import { VgSeekComponent } from './VgSeek.Component';
import { VgThumbnailPreviewComponent } from './VgThumbnailPreview.Component';
import { VgVolumeBarComponent } from './VgVolumeBar.Component';
import { VgVolumeComponent } from './VgVolume.Component';

const components = [
	VbScrubBarCurrentTimeBubbleComponent,
	VbScrubBarCurrentTimeComponent,
	VbTimeMarkersComponent,
	VgControlsComponent,
	VgFullscreenButtonComponent,
	VgMuteButtonComponent,
	VgPlayPauseButtonComponent,
	VgScrubBarComponent,
	VgSeekComponent,
	VgThumbnailPreviewComponent,
	VgVolumeBarComponent,
	VgVolumeComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		PipesModule,
		SharedModule,
		TooltipModule
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA
	]
})
export class VideogularControlsModule {}
